module.exports = __webpack_public_path__ + "img/temple.5ca368fa.jpeg";